<template>
  <form-row>
    <label class="ordered-counter">
      {{ $t(isStarProduct ? 'product-detail.form.term.label-star-product' : 'product-detail.form.term.label') }}
    </label>

    <ul class="order-tariff">
      <li v-for="term in termsToShow"
          :key="term.id"
          :class="[{ selected: selectedTerm && term.id === selectedTerm.id }]"
          @keypress.enter="updateValue(term)"
          @keypress.space="updateValue(term)"
          @click="updateValue(term)">
        <label>
          <div class="tariff-period" tabindex="0">
            {{ term.title }}
            <span class="age-group">{{ customerGroup.title }}</span>
          </div>

          <div class="price">
            {{ $n(priceFormTerm(term.id), 'currency') }}
            <span v-if="amountSaved(term) > 0" class="period-discount">
              {{ $t('generic.bespaar') }} {{ $n(amountSaved(term), 'currency') }}
            </span>
          </div>
        </label>
      </li>
    </ul>

    <ul v-if="(validation.$error && validation.$params.errorCode.satisfiableByCustomerGroup) || !termsToShow.length"
        class="ui-state-info"
        role="alert"
        aria-atomic="true"
        aria-live="polite">
      <li v-if="validation.$error && validation.$params.errorCode.satisfiableByCustomerGroup">
        {{ $tc(
          `product-detail.form.term.validation.${validation.$params.errorCode.code}`,
          2,
          { title: validation.$params.errorCode.satisfiableByCustomerGroup.title }
        ) }}
      </li>
      <li v-if="!termsToShow.length">{{ $t('product-detail.form.term.validation.no-terms-available') }}</li>
    </ul>

    <ul v-if="validation.$error && !validation.$params.errorCode.satisfiableByCustomerGroup && termsToShow.length"
        class="ui-state-error"
        role="alert"
        aria-atomic="true"
        aria-live="polite">
      <li v-if="!validation.required || !validation.hasConfiguration">{{ $t('product-detail.form.term.validation.required') }}</li>
      <li v-if="!validation.errorCode">
        {{ $tc(`product-detail.form.term.validation.${validation.$params.errorCode.code}`, 1) }}
      </li>
    </ul>
  </form-row>
</template>

<script>
import FormRow from '../components/FormRow'
import { CustomerGroup } from '../../types/filter-entity/customer-group'
import { Term } from '../../types/filter-entity/term'

export default {
  components: {
    FormRow
  },
  props: {
    selectedTerm: {
      type: Term,
      default: null
    },
    terms: {
      type: Array,
      required: true
    },
    configurations: {
      type: Array,
      required: true
    },
    customerGroupsToShow: {
      type: Array,
      required: true
    },
    customerGroup: {
      type: CustomerGroup,
      required: true
    },
    validation: {
      type: Object,
      default: () => ({})
    },
    isStarProduct: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    termsToShow: function () {
      const configurations = this.configurationsForCustomerGroup

      return this.terms.filter(
        term => term.nrOfProductConfigurations > 0 &&
          configurations.find(configuration => configuration.term.id === term.id)
      ).sort((a, b) => b.termsPerYear - a.termsPerYear)
    },
    configurationsForCustomerGroup: function () {
      return this.configurations.filter(configuration => configuration.customerGroup.id === this.customerGroup.id)
    },
    mostExpensiveConfiguration: function () {
      return this.configurationsForCustomerGroup.reduce((a, b) => (a.pricePerYear.amount > b.pricePerYear.amount) ? a : b)
    }
  },
  watch: {
    termsToShow: function () {
      if (this.termsToShow.length === 1) this.updateValue(this.termsToShow[0])
    }
  },
  methods: {
    updateValue: function (term) {
      this.$emit('input', term)
    },
    priceFormTerm: function (termId) {
      return this.configurations.find(
        configuration => configuration.term.id === termId && configuration.customerGroup.id === this.customerGroup.id
      ).price.amount
    },
    pricePerYearFormTerm: function (termId) {
      return this.configurations.find(
        configuration => configuration.term.id === termId && configuration.customerGroup.id === this.customerGroup.id
      ).pricePerYear.amount
    },
    amountSaved: function (term) {
      const saving = this.mostExpensiveConfiguration.pricePerYear.amount - this.pricePerYearFormTerm(term.id)

      return saving / term.termsPerYear
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/Term.vue